import VueSlickCarousel from 'vue-slick-carousel'

import { Slider, SliderItem, SliderItemJob } from '../components/slider'
import Highlights from '../components/highlights'
import Timelapse from '../components/timelapse'
import Newsletter from '../components/newsletter'
import Stage from '../components/stage'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'

import { getJobs } from '../api/jobs'

export default {
  name: 'Homepage',
  components: {
    Timelapse,
    Stage,
    Slider,
    SliderItem,
    SliderItemJob,
    Newsletter,
    Highlights,
    VueSlickCarousel,
  },
  data() {
    return {
      jobs: [],
      // eslint-disable-next-line prefer-template
      url: argus_url.site + '/job/',
      jobsRows: 2,
      clientSliderOptions: {
        arrows: false,
        autoplay: true,
        swipe: false,
        autoplaySpeed: 0,
        slidesToShow: 6,
        speed: 3000,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 426,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.fetchJobs()

    // Set num of
    const currentClientSlides = parseInt(this.$refs.client_slider.dataset.currentClients, 16)

    if (currentClientSlides < 6) {
      this.clientSliderOptions.slidesToShow = currentClientSlides
    } else {
      this.clientSliderOptions.slidesToShow = 6
    }
  },
  methods: {
    fetchJobs() {
      getJobs()
        .then(res => {
          this.jobs = res.data.categories.reduce((departs, curDepart) => {
            const jobs = curDepart.jobs.map(job => ({ department: curDepart.name.toLowerCase().replace(/[^a-z0-9_-]/, ''), ...job }))

            return [...jobs, ...departs]
          }, [])
        })
        .catch(e => {
          console.log('Jobs API Error!', e)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
